import React, { useContext } from "react";
import { BookContext } from '../../context/books';
import { Link } from "react-router-dom";
import "./BookList.css";
import coverImg from "../../images/cover_not_found.jpg";
import config from '../../aws-exports';

const {
    aws_user_files_s3_bucket_region: region,
    aws_user_files_s3_bucket: bucket
} = config

const Book = (book) => {
    const { idioma } = useContext(BookContext);
    switch (idioma) {
      case "español":
    return (
        <div className="book-item flex flex-column flex-sb">
          <Link to = {`/book/id/${book.id}`} {...book}>
            <div className="book-item-img">
                <img src = {book.portada ? `https://${bucket}.s3.${region}.amazonaws.com/images/${book.portada}` : coverImg} alt = "cover" />
            </div>
          </Link>
            <div className="book-item-info text-center">
                <Link to = {`/book/id/${book.id}`} {...book}>
                    <div className="book-inte-info-item title fw-7 fs-18">
                        <span>{book.titulo}</span>
                    </div>
                </Link>

                <div className="book-inte-info-item author fs-15">
                    <span className="text-capitalized fw-7">Autor: </span>
                    <span>{book.autor}</span>
                </div>

                <div className="book-inte-info-item edition-count fs-15">
                    <span className="text-capitalized fw-7">País de edición: </span>
                    <span>{book.pais}</span>
                </div>
                <div className="book-inte-info-item publish-year fs-15">
                    <span className="text-capitalized fw-7">Fecha de edición: </span>
                    <span>{book.anoedicion}</span>
                </div>
                <Link to = {`/book/id/${book.id}`} {...book}>
                <div className="book-inte-info-item author fw-3 fs-09">
                <span className="fw-3 fs-09">(Click para mas datos)</span>
                </div>
                </Link>
            </div>
        </div>
    )
    case "english":
        return (
            <div className="book-item flex flex-column flex-sb">
              <Link to = {`/book/id/${book.id}`} {...book}>
                <div className="book-item-img">
                    <img src = {book.portada ? `https://${bucket}.s3.${region}.amazonaws.com/images/${book.portada}` : coverImg} alt = "cover" />
                </div>
              </Link>
                <div className="book-item-info text-center">
                    <Link to = {`/book/id/${book.id}`} {...book}>
                        <div className="book-inte-info-item title fw-7 fs-18">
                            <span>{book.titulo}</span>
                        </div>
                    </Link>
    
                    <div className="book-inte-info-item author fs-15">
                        <span className="text-capitalized fw-7">Author: </span>
                        <span>{book.autor}</span>
                    </div>
    
                    <div className="book-inte-info-item edition-count fs-15">
                        <span className="text-capitalized fw-7">Edition's country: </span>
                        <span>{book.pais}</span>
                    </div>
                    <div className="book-inte-info-item publish-year fs-15">
                        <span className="text-capitalized fw-7">Edition's date: </span>
                        <span>{book.anoedicion}</span>
                    </div>
                    <Link to = {`/book/id/${book.id}`} {...book}>
                    <div className="book-inte-info-item author fw-3 fs-09">
                    <span className="fw-3 fs-09">(Click for more info)</span>
                    </div>
                    </Link>
                </div>
            </div>
        )
        default:
            break;
}
}

export default Book;